// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"440":"735b84f0a49fdb1b7ae4","581":"b02813d229919a71d369"}[chunkId] + ".js";
};